import styles from './BtnApplyNewTemplate.module.css';

export const BtnApplyNewTemplate = ({ isActive, action, name }) => {
  return (
    <button
      type='submit'
      className={styles.btnSubmit}
      disabled={!isActive}
      onClick={(evt) => window.confirm("Are you sure to apply new template?") && action(evt)}
    >
      {name}
    </button>
  );
}